var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "notfound-container" },
    [
      _c("img", { attrs: { src: _vm.notfound } }),
      _c("h1", [_vm._v("要访问的页面不存在")]),
      _c(
        "el-button",
        {
          attrs: { type: "primary", round: "" },
          on: {
            click: function ($event) {
              return _vm.$router.replace("/")
            },
          },
        },
        [_vm._v("返回首页")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }